import { useEffect, useState } from 'react';
import {
  Droppable as ReactBeautifulDroppable,
  type DroppableProps as ReactBeautifulDroppableProps,
} from 'react-beautiful-dnd';

// Since the react-beautiful-dnd is no longer maintained, it does not support React 18.
// This is a workaround suggested by the community: https://github.com/atlassian/react-beautiful-dnd/issues/2399#issuecomment-1175638194

export type DroppableProps = ReactBeautifulDroppableProps;

export const Droppable = ({ children, ...props }: DroppableProps) => {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const animation = requestAnimationFrame(() => setEnabled(true));

    return () => {
      cancelAnimationFrame(animation);
      setEnabled(false);
    };
  }, []);

  if (!enabled) {
    return null;
  }

  return (
    <ReactBeautifulDroppable {...props}>{children}</ReactBeautifulDroppable>
  );
};
